import React from 'react';
import { Button, ListGroup } from 'react-bootstrap';

/**
 * "Check these choices": one row per chosen position with the student's own
 * course answer, and an Edit button that returns to the step that asks it. The
 * course answer is information for the reviewer, never a requirement, and the
 * summary says so beside the answer.
 */
export default function ReviewChoicesCheck({ rows, onEdit }) {
    if (rows.length === 0) return null;
    return (
        <section aria-labelledby="review-check-heading" className="mb-4">
            <h3 id="review-check-heading" className="h6 mb-2">
                Check these choices
            </h3>
            <ListGroup>
                {rows.map((row) => (
                    <ListGroup.Item
                        key={row.id}
                        className="d-flex flex-wrap align-items-center justify-content-between gap-2"
                    >
                        <div>
                            <div className="fw-semibold">{row.title}</div>
                            {row.course !== null && (
                                <div className="small">
                                    Completed {row.courseLabel} (or its
                                    equivalent):{' '}
                                    <strong>{row.course ? 'Yes' : 'No'}</strong>
                                </div>
                            )}
                            {row.course === false && (
                                <div className="small text-body-secondary">
                                    You can still apply. This answer is for the
                                    faculty member reviewing, not a requirement.
                                </div>
                            )}
                        </div>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className="sap-edit-btn"
                            onClick={onEdit}
                            aria-label={`Edit your choices for ${row.title}`}
                        >
                            Edit
                        </Button>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </section>
    );
}
